import { render } from "./groupPhoto.vue?vue&type=template&id=a584a410&scoped=true"
import script from "./groupPhoto.vue?vue&type=script&lang=js"
export * from "./groupPhoto.vue?vue&type=script&lang=js"

import "./groupPhoto.vue?vue&type=style&index=0&id=a584a410&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a584a410"]])

export default __exports__